import PointChangeHistoryList from "./PointChangeHistoryList";

export default PointChangeHistoryList;